import React from 'react';

export const ProductColors = ({ colors }: { colors: string[] }) => {
  const uniqueColors = Array.from(new Set(colors));

  if (uniqueColors.length <= 1) {
    return null;
  }

  return (
    <ul className="grid grid-flow-col items-center justify-center gap-1">
      {uniqueColors.slice(0, 4).map((color, index) => (
        <li
          key={color}
          className="grid h-2 w-2 grid-flow-col items-center justify-center rounded-full"
          style={{ backgroundColor: color }}
        >
          {index === 0 && <div className="h-1 w-1 rounded-full bg-white" />}
        </li>
      ))}
      {uniqueColors.length > 4 && (
        <li className="inline-block h-2.5 text-xs/none font-bold uppercase text-black-400">
          +{uniqueColors.length - 4}
        </li>
      )}
    </ul>
  );
};
